import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import PurchaserClient from "../../clients/PurchaserClient";

export default function ConnectEmailCallback() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const createAccount = async (account: string) => {
        try {
            const userEmailSender = await PurchaserClient.createConnectedEmail(account);

            // TODO: Should we poll and wait for the state to be "connected"?
            if (userEmailSender && userEmailSender.emailEngineData) {
                const redirect = localStorage.getItem("post-connect-email-redirect") ?? "/";
                if (redirect.includes("rfq")) {
                    // If it does, redirect back to RFQ path
                    navigate(`${redirect}?senderAccount=${userEmailSender.emailEngineAccountId}`);
                }

                // TODO: Show an error state?
                // Or redirect to a fallback page? Currently this just redirects to / if no redirect was set
                navigate(redirect);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        const account = searchParams.get("account");
        if (account) {
            // Create sender connected to EmailEngine account
            createAccount(account);
        }
    }, [searchParams]);

    // TODO:
    // - Add loading state that says something like "validating account"

    return <div></div>;
}
